<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <SalabamLoginPage :service_title="service_title" :service_name="service_name"/>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import SalabamLoginPage from '@/components/salabam/SalabamLoginPage'

export default {
  name: 'SalabamVacanzeVadobay',
  data () {
    return {
        // Variabili generali
        tagline_elem : [ { text : "AlpitourWorld", link : 'conv-salabam-vacanze-vadobay' } ],

        // Nome welfarebit del servizio
        service_title : "AlpitourWorld",

        // Identificativo del servizio
        service_name : "vacanze-vadobay"
    }
  },
  components: {
    PageTagline,
    SalabamLoginPage
  }
}
</script>

<style scoped></style>